import React, { useContext } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import PatientBotGate from "./components/PatientBotGate";
import Clinician from "./components/Clinician";
import Home from "./components/Home";
import Login from "./components/Login";
import Register from "./components/Register";
import PatientRegisterWizard from "./components/PatientRegisterWizard";
import LabReports from "./components/LabReports";
import FreeConversion from "./components/FreeConversion";
import MyPayments from "./components/MyPayments";
import ChangePassword from "./components/ChangePassword";
import ForgotPassword from "./components/ForgotPassword";
import ResetPassword from "./components/ResetPassword";
import TermsOfUse from "./components/TermsOfUse";
import PrivacyPolicy from "./components/PrivacyPolicy";
import { UserProvider } from "./components/UserContext";
import UserContext from "./components/UserContext";
import ProtectedRoute from "./components/ProtectedRoute";
import AdminLogin from "./components/AdminLogin";
import AdminDashboard from "./components/AdminDashboard";
import AdminProtectedRoute from "./components/AdminProtectedRoute";
import LogisticsLogin from "./components/LogisticsLogin";
import LogisticsDashboard from "./components/LogisticsDashboard";
import TelehealthReviewLogin from "./components/TelehealthReviewLogin";
import TelehealthReviewDashboard from "./components/TelehealthReviewDashboard";
import SummaryViewPage from "./components/SummaryViewPage";
import MonthlyDigestPage from "./components/MonthlyDigestPage";

// After login, redirect based on role
function RoleHome() {
  const { user } = useContext(UserContext);
  if (!user) return <Navigate to="/" replace />;
  return <Home />;
}

function App() {
  return (
    <UserProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/register/patient" element={<PatientRegisterWizard />} />
          <Route
            path="/home"
            element={
              <ProtectedRoute>
                <RoleHome />
              </ProtectedRoute>
            }
          />
          <Route
            path="/patient-bot"
            element={
              <ProtectedRoute requiredRole="patient">
                <PatientBotGate />
              </ProtectedRoute>
            }
          />
          <Route
            path="/clinician-bot"
            element={
              <ProtectedRoute requiredRole="clinician">
                <Clinician />
              </ProtectedRoute>
            }
          />
          <Route
            path="/clinician-summary-view"
            element={
              <ProtectedRoute requiredRole="clinician">
                <SummaryViewPage variant="clinician" />
              </ProtectedRoute>
            }
          />
          <Route
            path="/telehealth-summary-view"
            element={<SummaryViewPage variant="telehealth" />}
          />
          <Route
            path="/monthly-digest"
            element={
              <ProtectedRoute requiredRole="patient">
                <MonthlyDigestPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/my-reports"
            element={
              <ProtectedRoute>
                <LabReports />
              </ProtectedRoute>
            }
          />
          <Route
            path="/free-conversion"
            element={
              <ProtectedRoute requiredRole="patient">
                <FreeConversion />
              </ProtectedRoute>
            }
          />
          <Route
            path="/my-payments"
            element={
              <ProtectedRoute requiredRole="patient">
                <MyPayments />
              </ProtectedRoute>
            }
          />
          <Route
            path="/change-password"
            element={
              <ProtectedRoute>
                <ChangePassword />
              </ProtectedRoute>
            }
          />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password"  element={<ResetPassword />} />
          <Route path="/terms"           element={<TermsOfUse />} />
          <Route path="/privacy"         element={<PrivacyPolicy />} />
          <Route path="/admin-login"     element={<AdminLogin />} />
          <Route
            path="/admin-dashboard"
            element={
              <AdminProtectedRoute>
                <AdminDashboard />
              </AdminProtectedRoute>
            }
          />
          <Route path="/logistics-login"              element={<LogisticsLogin />} />
          <Route path="/logistics-dashboard"           element={<LogisticsDashboard />} />
          <Route path="/telehealth-review-login"       element={<TelehealthReviewLogin />} />
          <Route path="/telehealth-review-dashboard"   element={<TelehealthReviewDashboard />} />
        </Routes>
      </Router>
    </UserProvider>
  );
}

export default App;
